(function (angular) {
    'use strict';
    var app = angular.module('enervee');

    /*
     PopoverService contains functions for interacting with registered popovers
     */

    app.factory('PopoverService', [
        '$log',
        function(
            $log
        ) {
            var _pub = {},
                _popovers = {};

            /**
             * Checks if the given popover has been registered.
             * @param popoverName
             * @returns {boolean}
             */
            var isPopoverRegistered = function(popoverName) {
                if (popoverName in _popovers) {
                    return true;
                } else {
                    $log.error('{} is not registered.'.format(popoverName));
                    return false;
                }
            };

            /**
             * Registers a popover by name and options.
             * Options should include any functions that will be used.
             * Example:
             * popoverName: 'utilitySelectorPopover'
             * popoverOptions:
             *      {open: $scope.showPopover, close: $scope.hidePopover}
             *
             * @param popoverName
             * @param popoverOptions
             */
            _pub.addPopover = function (popoverName, popoverOptions) {
                _popovers[popoverName] = popoverOptions;
            };

            /**
             * Calls the function associated with the action name. Logs an error if the popover isn't registered.
             * Logs an error if the action name isn't included in the options.
             * @param popoverName
             * @param action
             */
            _pub.interactWithPopover = function (popoverName, action) {
                if (isPopoverRegistered(popoverName)) {
                    if (action in _popovers[popoverName]) {
                        _popovers[popoverName][action]();
                    } else {
                        $log.error('{} function for {} not included.'.format(action, popoverName));
                    }
                }
            };

            return _pub;
        }
    ]);
})(angular);